import { createAppAsyncThunk } from '../appAsyncThunk';
import { downloadData } from 'aws-amplify/storage';
import { uploadData } from 'aws-amplify/storage';
import { UploadFile } from './types';
import { get } from 'aws-amplify/api';

export const uploadFileThunk = createAppAsyncThunk(
    'general/uploadFileThunk', async ({ fileName, file, callback }: UploadFile) => {
        const result = await uploadData({
            key: fileName,
            data: file,
            options: {
                accessLevel: 'private',
                onProgress: ({ transferredBytes, totalBytes }) => {

                    if (totalBytes && callback) {
                        callback((transferredBytes / totalBytes) * 100);
                    }
                }
            }
        }).result;

        return result.eTag;
    });

interface DownloadFile {
    path: string;
    fileName: string;
};

export const downloadFileThunk = createAppAsyncThunk(
    'general/downloadFileThunk', async ({ path, fileName }: DownloadFile) => {
        const downloadResult = await downloadData({
            key: path,
            options: { accessLevel: 'private' }
        }).result;

        const blob = await downloadResult.body.blob();
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        return blob;
    });

export const getJobInfoThunk = createAppAsyncThunk(
    'general/getJobInfoThunk', async (id: string, { rejectWithValue }) => {
        try {
            const restOperation = await get({
                apiName: 'jobInfo',
                path: '/jobInfo/{proxy+}',
                options: {
                    queryParams: { id }
                },
            }).response;

            const response = restOperation.body.json();
            return response as any;
        } catch (e) {
            return rejectWithValue('An error occurred, Try again later');
        }
    });
